module.exports = __webpack_public_path__ + "img/ic_option_03.02bfafc8.svg";